/* eslint-disable @typescript-eslint/no-explicit-any */
import { APP_FIELDS } from '../shared/constants/Constants';

import SignupFormModel from '../../components/FormBuilder/SignupFormModel';

function getVendorCategories(formDef: SignupFormModel): Array<string> {
  let { fields } = formDef;
  let categoryField = fields.getByID(APP_FIELDS.ID_FIELD_CATEGORY);

  if (
    !categoryField ||
    categoryField.definition.type !== 'MultichoiceElement'
  ) {
    return [];
  }

  return (categoryField.definition as any).options;
}

export default getVendorCategories;
